var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path, _path2, _path3, _circle9, _circle0, _circle1, _circle10, _path4, _path5, _path6, _circle11, _circle12, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorPageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 514,
    height: 164,
    viewBox: "0 0 514 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 22.0001,
    r: 20,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 142,
    r: 20,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 102,
    r: 20,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 102,
    r: 20,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 82.0001,
    r: 20,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 313,
    cy: 82.0001,
    r: 20,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 253,
    cy: 22.0001,
    r: 20,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 253,
    cy: 142,
    r: 20,
    stroke: "#667085",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 102C1 90.9544 9.9543 82.0001 21 82.0001H141C152.046 82.0001 161 90.9544 161 102C161 113.046 152.046 122 141 122H21C9.9543 122 1 113.046 1 102Z",
    stroke: "#667085",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101 162C89.9543 162 81 153.046 81 142L81 22C81 10.9543 89.9543 2 101 2C112.046 2 121 10.9543 121 22L121 142C121 153.046 112.046 162 101 162Z",
    stroke: "#667085",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14214 115.995C-0.668351 108.184 -0.668351 95.5212 7.14214 87.7107L86.7107 8.14216C94.5212 0.331675 107.184 0.331668 114.995 8.14215C122.805 15.9526 122.805 28.6159 114.995 36.4264L35.4264 115.995C27.6159 123.805 14.9526 123.805 7.14214 115.995Z",
    stroke: "#667085",
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 453,
    cy: 22.0001,
    r: 20,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 453,
    cy: 142,
    r: 20,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 373,
    cy: 102,
    r: 20,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 493,
    cy: 102,
    r: 20,
    stroke: "#667085",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M353 102C353 90.9544 361.954 82.0001 373 82.0001H493C504.046 82.0001 513 90.9544 513 102C513 113.046 504.046 122 493 122H373C361.954 122 353 113.046 353 102Z",
    stroke: "#667085",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M453 162C441.954 162 433 153.046 433 142L433 22C433 10.9543 441.954 2 453 2C464.046 2 473 10.9543 473 22L473 142C473 153.046 464.046 162 453 162Z",
    stroke: "#667085",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M359.142 115.995C351.332 108.184 351.332 95.5212 359.142 87.7107L438.711 8.14216C446.521 0.331675 459.184 0.331668 466.995 8.14215C474.805 15.9526 474.805 28.6159 466.995 36.4264L387.426 115.995C379.616 123.805 366.953 123.805 359.142 115.995Z",
    stroke: "#667085",
    strokeWidth: 2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 253,
    cy: 82.0001,
    r: 80,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 253,
    cy: 82.0001,
    r: 40,
    stroke: "#667085",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.74228e-8,
    y1: 1,
    x2: 513,
    y2: 1.00004,
    stroke: "#667085",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: -8.74228e-8,
    y1: 163,
    x2: 513,
    y2: 163,
    stroke: "#667085",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPageIcon);
export default __webpack_public_path__ + "static/media/errorPageIcon.2874caa742d05ccfb87cdd7ffe25c742.svg";
export { ForwardRef as ReactComponent };